import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import axios from 'axios'
import { setAccessToken } from './AuthStore.ts'

export default function AuthCallback() {
  const [msg, setMsg] = useState('로그인 처리 중...')
  const navigate = useNavigate() 

  useEffect(() => {
    const check = async () => {
      try {
        const response = await axios.get(
          `${import.meta.env.VITE_API_BASE}/api/user/me`,
          {
          withCredentials: true
        })
        
        if (response.status === 200) {
          const tokenResponse = await axios.post(
            `${import.meta.env.VITE_API_BASE}/api/auth/issue-token/${response.data.data.userId}`
          )
          const token = tokenResponse.data.data.token
          if (!token) throw new Error('JWT 발급 실패: token 없음')
  
          setAccessToken(token)

          if(response.data.data.isRegisterCompleted === false) {
            navigate('/signup', { state: { fromOAuth: true, startStep: 2 } })
          } else {
            navigate('/dashboard')
          }
          
        } else {
          const text = await response.text().catch(() => '')
          console.error('me check failed:', response.status, response.statusText, text)
          setMsg(`로그인 세션 확인 실패(${res.status}). 다시 시도해주세요.`)
        }
      } catch (e) {
        setMsg('네트워크 오류. 잠시 후 다시 시도해주세요.')
      }
    }

    check()
  }, [])

  return <div style={{ padding: 24 }}>{msg}</div>
}